import { Component, OnInit } from '@angular/core';
import { MapService } from '../../../services/map.service';

@Component({
  selector: 'ebw-map-zoom-out',
  templateUrl: './zoom-out.component.html',
  styleUrls: ['./zoom-out.component.scss']
})
export class ZoomOutComponent implements OnInit {

  buttonTooltip: string = "";

  constructor(private mapService: MapService) { }

  ngOnInit(): void {
  }
  
  zoomOut(){
    this.mapService.mapZoom -= 1;
  }

}
